import { render, staticRenderFns } from "./e-svg-icon.vue?vue&type=template&id=131a5b04&"
import script from "./e-svg-icon.vue?vue&type=script&lang=js&"
export * from "./e-svg-icon.vue?vue&type=script&lang=js&"
import style0 from "./e-svg-icon.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports